document.addEventListener('DOMContentLoaded', function () {
  positionMegaDropdownSubmenuColumns();
});

function getPageWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

/**
 * For every megadropdown menu where there is less than three
 * columns it gives those columns a margin equal to the distance
 * of the menu item to the side of the page so that the columns
 * start nicely straight under the menu item.
 */
function positionMegaDropdownSubmenuColumns() {
  const pageWidth = getPageWidth();
  const menu = document.querySelector('.sidebar-main-page ul');
  const menuItems = [].slice.call(
    document.querySelectorAll('.sidebar-main-page .nav-item')
  );
  const menuLeft = menu.getBoundingClientRect().left;
  menuItems.forEach($menuItem => {
    const $link = $menuItem.querySelector('.nav-link');
    if (!$link) {
      return;
    }
    const menuItemLeft = $link.getBoundingClientRect().left;
    const subMenuItems = [].slice.call(
      $menuItem.querySelectorAll('.mega-dropdownmenu > ul > li')
    );
    if (
      subMenuItems.length == 0 ||
      subMenuItems.length > 3 ||
      pageWidth < 900
    ) {
      return;
    }
    subMenuItems[0].style.marginLeft = `${menuItemLeft - menuLeft}px`;
  });
}
